const newInspection = {
  buttons: {
    backbtn: "Go Back",
    submit: "Submit",
    ok: "OK",
    cancel: "Cancel",
    yes: "yes",
    no: "No, just the inspection"
  },
  messages: {
    addTask: "Do you wish to add another task?"
  }
};
export default newInspection;
